<template>
  <TitleWrapper
    title="Fee"
    additional-name="Settings"
    :is-buttons-hidden="true"
    :is-right-bar-button-hidden="true"
  />
  <UITabs v-model="activePage" :tabs-list="tabsList" />
  <div v-if="activePage === FEATURES_TABS.GENERAL">
    <NoRecordFound />
  </div>
  <div v-else-if="activePage === FEATURES_TABS.PERMISSION">
    <FeatureSettingsPermissionsView :feature-name="MYQAMPUS_FEATURE_NAMES.FEE_MANAGER" />
  </div>
  <div v-else-if="activePage === FEATURES_TABS.NOTIFICATION">
    <FeeNotification />
  </div>
</template>

<script>
import FeatureSettingsPermissionsView from '@/src/router/views/settings/system-settings/FeatureSettingsPermissionsView.vue'
import { MYQAMPUS_FEATURE_NAMES } from '@/src/constants/feature-name-constants'
import NoRecordFound from '@src/components/BaseComponent/NoRecordFound.vue'
import FeeNotification from '@/src/router/views/settings/notifications/fee.vue'
import { FEATURES_TABS_LIST, FEATURES_TABS } from '@src/constants/general-constants.js'
import UITabs from '@src/components/UiElements/UITabs.vue'
import TitleWrapper from '@components/TitleWrapper.vue'
export default {
  name: 'Settings',
  components: {
    UITabs,
    TitleWrapper,
    NoRecordFound,
    FeeNotification,
    FeatureSettingsPermissionsView,
  },
  page: {
    title: 'Features Settings',
  },
  data() {
    return {
      FEATURES_TABS,
      MYQAMPUS_FEATURE_NAMES,
      tabsList: FEATURES_TABS_LIST,
      activePage: FEATURES_TABS.GENERAL,
    }
  },
}
</script>
